import {
  Avatar,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CButton from "../utils/CButton";
import CAlert from "../utils/CAlert";
import { useDispatch, useSelector } from "react-redux";
import { WebcamCapture } from "../../helper/Webcam";
import { setAppLoader } from "../../actions/setAppLoader";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { uploadFile } from "../../services/studentService";
import {
  faceVerify,
  deleteFile,
  saveFaceData,
  getFileImage,
  saveSalesId,
} from "../../services/faceVerificationService";
import { lead, uploadCb, onboard } from "../../services/lmsService";
import success from "../../assets/images/Vector.svg";
import failure from "../../assets/images/failure.svg";
import { saveFormPath } from "../../services/userService";
import { generatePDF, finalSubmit } from "../../services/pdfService";
import { getUserData } from "../../actions/getUserData";
import CInput from "../utils/CInput";
import { Box } from "@mui/system";
import { generateEquifax } from "../../services/pdfService";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getLoanStatus, initiateLoan } from "../../services/avanseService";
import { resendVerificationEmail, changeEmailAndResend, getEmailVerificationStatus } from "../../services/authenticationService";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

export default function FaceVerificationV1({
  setTabValue,
  setStepperCount,
  userDetailId,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputRef = React.useRef(null);
  const [openCamera, setOpenCamera] = React.useState(false);
  const [captureImage, setCaptureImage] = React.useState("");
  const [isVerified, setIsVerified] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const [uploadFileURL, setUploadFileURL] = React.useState("");
  const [faceMatchScore, setFaceMatchScore] = React.useState("");
  const [displayFile, setDisplayFile] = React.useState("");
  const [isSales, setIsSales] = React.useState("true");
  const [salesId, setSalesId] = React.useState("");
  const [salesIdData, setSalesIdData] = React.useState("");
  const [disableSubmit, setDisableSubmit] = React.useState(true);
  const [showTermsC, setShowTermsC] = React.useState(false);

  const userDetails = useSelector((state) => state?.getUserData?.data);
  const isFetching = useSelector((state) => state?.getUserData?.isFetching);
  const userAadharImage = userDetails?.aadharDetails?.userImageId;
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [lender, setLender] = React.useState('')
  const [showEmailGate, setShowEmailGate] = React.useState(false);
  const [emailResent, setEmailResent] = React.useState(false);
  const [showChangeEmailModal, setShowChangeEmailModal] = React.useState(false);
  const [newEmail, setNewEmail] = React.useState('');
  const [changingEmail, setChangingEmail] = React.useState(false);
  const [resendingEmail, setResendingEmail] = React.useState(false);
  const [verifiedByPolling, setVerifiedByPolling] = React.useState(false);
  const pollIntervalRef = useRef(null);

  useEffect(() => {
    dispatch(getUserData(userDetailId));
  }, []);

  React.useEffect(() => {
    dispatch(setAppLoader(false));
  }, [isFetching]);

  React.useEffect(() => {
      setLender(userDetails?.lender || '');
  }, [userDetails]);

  useEffect(() => {
    (async function () {
      if (userDetails?.faceImage) {
        const splitFile = userDetails?.faceImage?.split("/");
        const obj = {
          fileName: `${splitFile[3]}/${splitFile[4]}`,
        };
        const dFile = await getFileImage(obj);
        setDisplayFile(dFile?.data);
        setIsVerified(true);
        setFaceMatchScore(userDetails?.userFaceMatchScore);
        setUploadFileURL(userDetails?.faceImage);
        setSalesId(userDetails?.salesPersonDetails?.salesId);
        setSalesIdData(userDetails?.salesPersonDetails?.salesPersonId);
      }
    })();
  }, [userDetails]);

  function openCameraFunction() {
    setOpenCamera(true);
    setCaptureImage("");
  }
  const onRadioChange = (event) => {
    setIsSales(event.target.value);
    if (event.target.value === "false") {
      setSalesIdData("");
    }
  };

  const hasValidSalesData = React.useCallback(() => {
    if (isSales === "true" && !salesIdData) return false;
    if (isSales === "true" && !(salesIdData.trim().length > 0)) return false;
    return true;
  }, [isSales, salesIdData]);

  const canSubmitForm = React.useCallback(() => {
    if (!uploadFileURL) return false;
    if (!hasValidSalesData()) return false;
    return true;
  }, [uploadFileURL, hasValidSalesData]);

  useEffect(() => {
    setDisableSubmit(!canSubmitForm());
  }, [canSubmitForm]);

  async function proceedWithLoanFlow() {
    dispatch(setAppLoader(true));
    let breResp = {};
    if (lender === "avanse") {
      breResp = await getLoanStatus(userDetails?.detailId);
      await initiateLoan(userDetails?.detailId);
    } else {
      // OneFin/LMS onboarding disabled: relying fully on manual BRE (UnderWritingTable/saveFallback) for non-Avanse lenders.
      // PDF and Equifax generation are still needed and remain active.
      await generatePDF(userDetails?.user?.userName, userDetailId);
      await generateEquifax(userDetails?.user?.userName, userDetails?.detailId);
      // await lead(userDetails?.detailId);
      // await uploadCb(userDetails?.detailId);
      // breResp = await onboard(userDetails?.detailId, null, null);
    }
    dispatch(setAppLoader(false));
    setStepperCount(7);
    setTabValue(10);

    if (breResp.status && breResp.status === 200) {
      if (breResp.data.data.status === "Approved") {
        saveFormPath("/loanApproved", userDetails?.detailId);
        navigate("/loanApproved", { state: { tabValue: 10, stepperCount: 6, userDetailId } });
      } else if (breResp.data.data.status === "Rejected") {
        saveFormPath("/loanDeclined", userDetails?.detailId);
        navigate("/loanDeclined", { state: { tabValue: 10, stepperCount: 6, userDetailId } });
      } else {
        saveFormPath("/loanStatus", userDetails?.detailId);
        navigate("/loanStatus", { state: { tabValue: 10, stepperCount: 6, userDetailId } });
      }
    } else {
      saveFormPath("/loanStatus", userDetailId);
      navigate("/loanStatus", { state: { tabValue: 10, stepperCount: 6, userDetailId } });
    }
  }

  useEffect(() => {
    if (!showEmailGate) return;

    pollIntervalRef.current = setInterval(async () => {
      try {
        const res = await getEmailVerificationStatus();
        if (res?.data?.status === "VERIFIED") {
          clearInterval(pollIntervalRef.current);
          setVerifiedByPolling(true);
          setTimeout(() => proceedWithLoanFlow(), 1500);
        }
      } catch (_) {
        // ignore transient poll errors
      }
    }, 5000);

    return () => clearInterval(pollIntervalRef.current);
  }, [showEmailGate]);

  async function onSubmitFaceVerication(e) {
    if (!canSubmitForm()) {
      setError(true);
      if (!hasValidSalesData()) {
        setErrorMsg("Please valid sales details to proceed");
      } else {
        setErrorMsg("Please capture your valid photo to proceed");
      }
    }
    if (userDetails?.formPath !== "/faceMatch") {
      navigate(userDetails?.formPath, {
        state: {
          tabValue: 10,
          stepperCount: 6,
          userDetailId: userDetailId,
          alreadySubmitted: true,
        },
      });
      return;
    }
    e.preventDefault();
    dispatch(setAppLoader(true));
    const obj = {
      userInstituteDetailId: userDetails?.detailId,
      faceImage: uploadFileURL,
      faceMatchScore: +faceMatchScore,
    };
    await saveFaceData(obj);
    const salesObj = {
      salesId: salesId,
      salesPersonId: salesIdData,
      createdBy: userDetails?.user?.userName,
      userInstituteDetailId: userDetails?.detailId,
    };
    if (isSales === "true") {
      await saveSalesId(salesObj);
    }
    //if (saveFace.status === 200) {
    // Email must be verified before proceeding with any lender
    if (userDetails?.user?.emailVerificationStatus !== "VERIFIED") {
      dispatch(setAppLoader(false));
      setShowEmailGate(true);
      return;
    }
    //await finalSubmit(userDetails?.detailId, "Submit", "")
    await proceedWithLoanFlow();
    //}
  }

  function urltoFile(url, filename, mimeType) {
    const arr = url.split(',');
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) { u8arr[n] = bstr.charCodeAt(n); }
    return new File([u8arr], filename, { type: mimeType });
  }

  async function verifyImage(imageToVerify) {
    const formData = new FormData();
    const url = imageToVerify;
    const file = await urltoFile(
      url,
      `${userDetails?.user?.userName}.jpeg`,
      "image/jpeg"
    );
    formData.append("file", file);
    formData.append("delimeter", userDetails?.user?.userName);
    formData.append("detailId", +localStorage.getItem("detailId"));
    const fileData = await uploadFile(formData, true);

    const fileData1 = await uploadFile(formData, false);
    if (fileData.status === 200) {
      setUploadFileURL(fileData1.data);
      setIsVerified(true);
    } else {
      setError(true);
      setErrorMsg("Image upload failed, Try Again");
    }
  }

  function handleBack() {
    if (
      userDetails?.instituteAddress?.instituteRiskCode === 4 ||
      userDetails?.instituteAddress?.instituteRiskCode === 3
    ) {
      navigate("/personalDetails", {
        state: { tabValue: 6, stepperCount: 5, userDetailId: userDetailId },
      });
    } else {
      setTabValue(8);
      navigate("/bankDetails", {
        state: { tabValue: 8, stepperCount: 7, userDetailId: userDetailId },
      });
    }
  }

  function onCaptureImage(image) {
    setCaptureImage(image);
    verifyImage(image);
  }

  function showTerm() {
    setShowTermsC(!showTermsC);
  }

  async function handleResendFromGate() {
    setResendingEmail(true);
    await resendVerificationEmail();
    setResendingEmail(false);
    setEmailResent(true);
  }

  async function handleChangeEmail() {
    if (!newEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)) return;
    setChangingEmail(true);
    await changeEmailAndResend(newEmail);
    setChangingEmail(false);
    setShowChangeEmailModal(false);
    setEmailResent(true);
  }

  if (showEmailGate) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: 2, p: 4, textAlign: 'center' }}>
        <Typography variant="h5" fontWeight="bold" color="textColor">
          Email Verification Required
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Please verify your email address before we can proceed with your Avanse loan application.
        </Typography>
        {verifiedByPolling ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, mt: 1 }}>
            <Typography variant="body1" color="success.main" fontWeight="bold">
              Email verified! Proceeding with your application…
            </Typography>
            <CircularProgress size={24} color="success" />
          </Box>
        ) : (
          <>
            {emailResent ? (
              <Typography variant="body2" color="success.main" fontWeight="bold">
                Verification email sent! Please check your inbox.
              </Typography>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="error"
                  disabled={resendingEmail}
                  onClick={handleResendFromGate}
                  sx={{ mt: 1 }}
                >
                  {resendingEmail ? 'Sending…' : 'Resend Verification Email'}
                </Button>
                <Button
                  variant="outlined"
                  color="neutral"
                  onClick={() => setShowChangeEmailModal(true)}
                  sx={{ mt: 1 }}
                >
                  Change Email
                </Button>
              </>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
              <CircularProgress size={16} color="inherit" />
              <Typography variant="body2" color="textSecondary">
                Checking for verification automatically…
              </Typography>
            </Box>
          </>
        )}

        <Dialog open={showChangeEmailModal} onClose={() => setShowChangeEmailModal(false)} fullWidth maxWidth="xs">
          <DialogTitle>Change Email Address</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              fullWidth
              type="email"
              label="New Email Address"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              sx={{ mt: 1 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowChangeEmailModal(false)} color="neutral">Cancel</Button>
            <Button
              onClick={handleChangeEmail}
              variant="contained"
              color="error"
              disabled={changingEmail || !newEmail}
            >
              {changingEmail ? 'Updating…' : 'Update & Send Link'}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }

  return (
    <form
      onSubmit={(e) => onSubmitFaceVerication(e)}
      c
      className="applicationFormContainer"
    >
      {error ? (
        <CAlert open={error} message={errorMsg} severity="error" />
      ) : null}
      {errorMsg === "Data Saved Successfully" ? (
        <CAlert open={true} message={errorMsg} severity="success" />
      ) : null}
      {!matches && (
        <Box sx={{ display: "flex" }}>
          <ArrowBackIosIcon onClick={() => handleBack()} />
        </Box>
      )}
      <Grid item xs={12}>
        {
          matches ? (
            <Typography
              color="textColor"
              variant="subtitle1"
              sx={{ textAlign: "left" }}
            >
              Capture Selfie
            </Typography>
          ) : null
          // <Typography color='textColor' variant="subtitle3" sx={{ mb: 4, fontWeight: "bold", textAlign: "center" }}>Face Match</Typography>
        }
      </Grid>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {matches ? (
          <Grid sx={{ textAlign: "left" }} item xs={12}>
            <Typography
                color="textColorR"
                variant="body2"
                sx={{ fontWeight: "bold", textAlign: "left" }}
              >
                Your photograph is captured for identity matching purposes only.
              </Typography>
            <Typography
              color="textColor"
              variant="aadharLabel"
              sx={{ textAlign: "left" }}
            >
              Face Verification
            </Typography>
          </Grid>
        ) : (
          <Grid sx={{ textAlign: "center" }} item xs={12}>
            <Typography
              color="textColor"
              variant="aadharLabel"
              sx={{ textAlign: "left" }}
            >
              Click picture
            </Typography>
          </Grid>
        )}
        {matches ? (
          <Grid sx={{ textAlign: "left" }} item xs={6}>
            {openCamera && !captureImage && (
              <WebcamCapture
                setOpenCamera={setOpenCamera}
                setCaptureImage={(image) => onCaptureImage(image)}
              />
            )}
            {/* disabled={isVerified}  */}
            {!openCamera && (
              <Button
                onClick={openCameraFunction}
                color="uploadButton"
                fullWidth
                variant="contained"
                startIcon={<AddAPhotoIcon />}
              >
                Open Camera
              </Button>
            )}
          </Grid>
        ) : (
          <Grid sx={{ textAlign: "center" }} item xs={12}>
            {openCamera && !captureImage && (
              <WebcamCapture
                setOpenCamera={setOpenCamera}
                setCaptureImage={(image) => onCaptureImage(image)}
              />
            )}
            {!openCamera && (
              <CameraAltOutlinedIcon
                sx={{ fontSize: 60 }}
                onClick={openCameraFunction}
              />
            )}
          </Grid>
        )}
        <Grid sx={{ textAlign: "left" }} item md={6}></Grid>
        {captureImage && !isVerified && (
          <Grid sx={{ textAlign: "left" }} item xs={12}>
            <Typography
              color="textColor"
              variant="aadharLabel"
              sx={{ textAlign: "left" }}
            >
              Image
            </Typography>
          </Grid>
        )}
        <Grid
          sx={{
            textAlign: "left",
            display: "flex",
            alignItems: "end",
            gap: "10px",
          }}
          item
          xs={12}
        >
          {captureImage && (
            <React.Fragment>
              <img
                style={{ width: "30%", height: "100%" }}
                src={captureImage}
              />
              {/* <CButton handleClick={() => verifyImage()} name="Verify" /> */}
            </React.Fragment>
          )}
        </Grid>

        <Grid
          sx={{ display: "flex", alignItems: "center", gap: "5px" }}
          item
          xs={12}
        >
          {captureImage && (
            <React.Fragment>
              <img src={success} />
              <Typography
                color="textColor"
                variant="body2"
                sx={{ textAlign: "left" }}
              >
                Image Captured
              </Typography>
            </React.Fragment>
          )}
        </Grid>

        {uploadFileURL && isVerified && displayFile && (
          <Grid sx={{ textAlign: "left" }} item xs={6}>
            <Avatar
              sx={{ width: 100, height: 100 }}
              src={displayFile}
              variant="square"
            ></Avatar>
          </Grid>
        )}
        {!matches && (
          <Grid item sx={{ my: 2 }} xs={12}>
            <Divider style={{ background: "#616161" }} />
          </Grid>
        )}
        {matches && (
          <Grid
            sx={{ mb: { xs: 5 }, my: { sm: 5 }, textAlign: "left" }}
            item
            xs={12}
          >
            <Divider />
          </Grid>
        )}
        <Grid sx={{ pt: 1, textAlign: "left" }} item xs={12}>
          {matches ? (
            <Typography
              color="textColor"
              variant="subtitle1"
              sx={{ textAlign: "left" }}
            >
              Confirm Your Loan
            </Typography>
          ) : (
            <Typography
              color="textColor"
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                fontFamily: "Poppins",
              }}
            >
              Loan Summary
            </Typography>
          )}
        </Grid>
        <Grid sx={{ pt: 1, textAlign: "left" }} item xs={12}>
          <Typography
            color="textColor"
            variant="Label20"
            sx={{ textAlign: "left" }}
          >
            Here is the summary of your selected scheme
          </Typography>
        </Grid>
        <Grid sx={{ mt: 3, textAlign: "left" }} item xs={12}>
          <Typography
            color="textColor"
            variant="body1"
            sx={{ textAlign: "left" }}
          >
            Flyhi Study Loans- {userDetails?.instituteName?.instituteName} -{" "}
            {userDetails?.loanTenure} month
          </Typography>
        </Grid>
        {matches && (
          <Grid sx={{ my: 1, textAlign: "left" }} item xs={12}>
            <Divider />
          </Grid>
        )}
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ fontWeight: "bold", textAlign: "left" }}
          >
            Loan Amount
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {userDetails?.loanAmount}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ fontWeight: "bold", textAlign: "left" }}
          >
            Tenure
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {userDetails?.loanTenure}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ fontWeight: "bold", textAlign: "left" }}
          >
            EMI Type
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >{`${userDetails?.schemeDetails?.numberOfAdvanceEmis} - Advance`}</Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ fontWeight: "bold", textAlign: "left" }}
          >
            EMI{" "}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {userDetails?.emiAmount}{" "}
            {userDetails?.instituteAddress?.interestBourneByInstitute
              ? "(This amount is not inclusive of interest. Interest will be paid by selected institute)"
              : null}
            {userDetails?.lender === "avanse" && (
              <Typography
                component="div"
                sx={{ color: "red", fontStyle: "bold", fontSize: "0.75em", mt: 0.5 }}
              >
                <strong>*</strong> EMI amount will change based on actual disbursement date.
              </Typography>
            )}
          </Typography>
        </Grid>
        {/* <Grid sx={{ textAlign: "left" }} item xs={5}>
                    <Typography color='textColor' variant='aadharLabel' sx={{ fontWeight: "bold", textAlign: "left" }}>Interest Cost</Typography>
                </Grid>
                <Grid sx={{ textAlign: "left" }} item xs={5}>
                    <Typography color='textColor' variant='aadharLabel' sx={{ textAlign: "left" }}>xxxx</Typography>
                </Grid> */}
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ fontWeight: "bold", textAlign: "left" }}
          >
            APR
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >
            {userDetails?.apr}
            {userDetails?.lender === "avanse" && (
              <Typography
                component="div"
                sx={{ color: "red", fontStyle: "bold", fontSize: "0.75em", mt: 0.5 }}
              >
                <strong>*</strong> APR will change based on actual disbursement date.
              </Typography>
            )}
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ fontWeight: "bold", textAlign: "left" }}
          >
            Processing Fees
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "left" }} item xs={5}>
          <Typography
            color="textColor"
            variant="aadharLabel"
            sx={{ textAlign: "left" }}
          >{`${userDetails?.processingFees} (GST Applicable)`}</Typography>
        </Grid>
        {matches && (
          <Grid sx={{ my: 1, textAlign: "left" }} item xs={12}>
            <Divider />
          </Grid>
        )}

        <>
          <Grid sx={{ textAlign: "left", mt: 3 }} item xs={12}>
            <Typography
              color="textColor"
              variant="aadharLabel"
              sx={{ fontWeight: "bold", textAlign: "left" }}
            >
              Did a sales person help you fill this applications?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={isSales}
              name="radio-buttons-group"
              onChange={onRadioChange}
            >
              <FormControlLabel
                value={true}
                control={<Radio />}
                label={
                  <Typography color="textColor" variant="aadharLabel">
                    Yes
                  </Typography>
                }
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label={
                  <Typography color="textColor" variant="aadharLabel">
                    No
                  </Typography>
                }
              />
            </RadioGroup>
          </Grid>
          <Grid sx={{ display: "flex", textAlign: "left" }} item xs={12}>
            <Typography
              color="textColor"
              variant="aadharLabel"
              sx={{ fontWeight: "bold", textAlign: "left" }}
            >
              Enter Sales Person ID/Name
            </Typography>
            <Box sx={{ ml: 3, width: "150px" }}>
              <CInput
                name="salesID"
                disabled={isSales !== "true"}
                value={salesIdData}
                onChange={setSalesIdData}
              />
            </Box>
          </Grid>
        </>

        {matches ? (
          <Grid sx={{ textAlign: "left", mt: 3 }} item xs={12}>
            <Typography
              color="textColor"
              variant="aadharLabel"
              sx={{ fontWeight: "bold", textAlign: "left" }}
            >
              Terms and Conditions
            </Typography>
          </Grid>
        ) : (
          <Grid sx={{ pt: 1, textAlign: "left" }} item xs={12}>
            {
              <Grid
                sx={{
                  textAlign: "center",
                  mt: 3,
                  display: "flex",
                  justifyContent: "center",
                }}
                item
                xs={12}
              >
                <Typography
                  color="textColor"
                  variant="subtitle2"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontFamily: "Poppins",
                  }}
                >
                  Terms and Conditions
                </Typography>
                <ExpandMoreIcon sx={{ mt: 1 }} onClick={showTerm} />
              </Grid>
            }
          </Grid>
        )}
      </Grid>
      {matches ? (
        <Grid
          sx={{
            pt: 2,
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
          }}
          item
        >
          <Typography color="textColor" variant="aadharLabel">
            1. The loan disbursement is subject to successful payment of
            processing fee and advance EMI if applicable.
          </Typography>
          <Typography color="textColor" variant="aadharLabel">
            2. In case the Processing Fee and Advance EMI (if applicable) is not
            paid after signing the loan agreement, the customer hereby
            authorizes Flyhi Finance to collect using the registered mandate.
          </Typography>
          <Typography color="textColor" variant="aadharLabel">
            3. Disbursement will be made to Institute's Bank account after
            mandate registration and verification of documents if any.
          </Typography>
          <Typography color="textColor" variant="aadharLabel">
            4. Detailed repayment schedule and welcome letter will be sent to
            your registered email ID.
          </Typography>
          <Typography color="textColor" variant="aadharLabel">
            5. By signing the loan agreement, we assume you have read the Terms
            and Conditions.
          </Typography>
        </Grid>
      ) : (
        showTermsC && (
          <Grid
            sx={{
              pt: 2,
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
            }}
            item
          >
            <Typography color="textColor" variant="aadharLabel">
              1. The loan disbursement is subject to successful payment of
              processing fee and advance EMI if applicable.
            </Typography>
            <Typography color="textColor" variant="aadharLabel">
              2. In case the Processing Fee and Advance EMI (if applicable) is
              not paid after signing the loan agreement, the customer hereby
              authorizes Flyhi Finance to collect using the registered mandate.
            </Typography>
            <Typography color="textColor" variant="aadharLabel">
              3. Disbursement will be made to Institute's Bank account after
              mandate registration and verification of documents if any.
            </Typography>
            <Typography color="textColor" variant="aadharLabel">
              4. Detailed repayment schedule and welcome letter will be sent to
              your registered email ID.
            </Typography>
            <Typography color="textColor" variant="aadharLabel">
              5. By signing the loan agreement, we assume you have read the
              Terms and Conditions.
            </Typography>
          </Grid>
        )
      )}
      <div
        style={{
          padding: "20px 0px 0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: `${!matches ? "space-around" : "space-between"}`,
        }}
      >
        {matches && <CButton handleClick={() => handleBack()} name="Back" />}
        <Button
          type="submit"
          sx={{ fontStyle: "Lato" }}
          color="neutral"
          disabled={disableSubmit}
          variant="contained"
        >
          Save & Submit
        </Button>
      </div>
    </form>
  );
}
